module.exports = __webpack_public_path__ + "static/media/YB5M05_1.16de5839.jpg";